export default function (zipcode) {
    return zipcode.match(
        /^[a-z0-9]+$/i
    );
}
